import { lazy } from 'react';

export const InventoryPageAsync = lazy(() => import('./InventoryPage'));
